import React from "react";
import { motion } from "framer-motion";
import { BookOpen, Users } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
const FeatureCards: React.FC = () => {
  const fadeInUp = {
    initial: {
      y: 30,
      opacity: 0
    },
    animate: {
      y: 0,
      opacity: 1
    },
    transition: {
      duration: 0.5
    }
  };
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
      <motion.div className="rounded-lg overflow-hidden" {...fadeInUp}>
        <Card>
          <CardContent className="pt-6">
            <div className="text-center">
              <div className="bg-[#E8F0F8] mx-auto mb-4 rounded-full p-3 w-16 h-16 flex items-center justify-center">
                <BookOpen className="text-[#333B44] h-8 w-8" />
              </div>
              <h3 className="text-xl font-medium mb-2">Journal Anytime You Want – Completely Free!</h3>
              <p className="text-[#333B44]">Clou helps you track your mood, emotions, and thoughts in your own secure personal diary, designed to support your mental health journey. Record conversations or arguments, capturing real-time discussions for your personal record or to share with your therapist.</p>
            </div>
          </CardContent>
        </Card>
      </motion.div>

      <motion.div className="rounded-lg overflow-hidden" {...fadeInUp}>
        <Card>
          <CardContent className="pt-6">
            <div className="text-center">
              <div className="bg-[#E8F0F8] mx-auto mb-4 rounded-full p-3 w-16 h-16 flex items-center justify-center">
                <svg className="text-[#333B44] h-8 w-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
                </svg>
              </div>
              <h3 className="text-xl font-medium mb-2">Track Mood Patterns</h3>
              <p className="text-[#333B44]">Unlock the power to visualise your emotional patterns with Clou. Gain deeper insights into your mental well-being, empowering you to better understand and navigate your emotions.</p>
            </div>
          </CardContent>
        </Card>
      </motion.div>

      <motion.div className="rounded-lg overflow-hidden" {...fadeInUp}>
        <Card>
          <CardContent className="pt-6">
            <div className="text-center">
              <div className="bg-[#E8F0F8] mx-auto mb-4 rounded-full p-3 w-16 h-16 flex items-center justify-center">
                <Users className="text-[#333B44] h-8 w-8" />
              </div>
              <h3 className="text-xl font-medium mb-2">Therapist Connection</h3>
              <p className="text-[#333B44]">Optionally choose to securley share entries with one of Clou's list of therapists. Deepen your therapy sessions, giving your Therapist a clearer view of your journey, helping you make even greater strides in your growth.</p>
            </div>
          </CardContent>
        </Card>
      </motion.div>
    </div>;
};
export default FeatureCards;
